var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"margin-top":"200px","text-align":"center"}},[_c('h2',[_vm._v("Finish")]),_c('v-card-actions',{staticClass:"justify-center"},[_c('v-btn',{attrs:{"color":"primary","to":"/exam"}},[_vm._v("Back to exam")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }